export const SECTOR_API_PATH = {
  GET_ALL: "v1/sectors/",
  GET_SECTOR_USAGE_SNAPSHOT: "v1/insights/sector/{0}/usage-snapshot/",
  GET_SECTOR_PRODUCTIVITY: "v1/insights/sector/{0}/productivity-snapshot/",
};
